
define('text!v3/Common/Components/PupilDropdown/PupilDropdown.Component.html',[],function () { return '<dropdown params="options: pupils, value: selectedPupilId, optionsText: \'longName\', optionsValue: \'pupilId\', disabled: disabled, valueAllowUnset: true"></dropdown>';});

